<template>
  <div v-show="pageShow">
    <Header/>
    <div class="content-wrapper">
      <div class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h1 class="m-0 text-dark">Dashboard</h1>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item">
                  <a href="#">Home</a>
                </li>
                <li class="breadcrumb-item active">Dashboard v2</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <section class="content">
        <div class="container-fluid">
          <div class="row">
            <div class="col-lg-3 col-6">
              <div class="small-box bg-info">
                <div class="inner">
                  <h3>150</h3>

                  <p>New Orders</p>
                </div>
                <div class="icon">
                  <i class="fas fa-briefcase"></i>
                </div>
                <a href="#" class="small-box-footer">
                  More info
                  <i class="fa fa-arrow-circle-right"></i>
                </a>
              </div>
            </div>
            <div class="col-lg-3 col-6">
              <div class="small-box bg-success">
                <div class="inner">
                  <h3>
                    53
                    <sup style="font-size: 20px">%</sup>
                  </h3>

                  <p>Bounce Rate</p>
                </div>
                <div class="icon">
                  <i class="fas fa-chart-bar"></i>
                </div>
                <a href="#" class="small-box-footer">
                  More info
                  <i class="fa fa-arrow-circle-right"></i>
                </a>
              </div>
            </div>
            <div class="col-lg-3 col-6">
              <div class="small-box bg-warning">
                <div class="inner">
                  <h3>44</h3>

                  <p>User Registrations</p>
                </div>
                <div class="icon">
                  <i class="fas fa-users"></i>
                </div>
                <a href="#" class="small-box-footer">
                  More info
                  <i class="fa fa-arrow-circle-right"></i>
                </a>
              </div>
            </div>
            <div class="col-lg-3 col-6">
              <div class="small-box bg-danger">
                <div class="inner">
                  <h3>65</h3>

                  <p>Unique Visitors</p>
                </div>
                <div class="icon">
                  <i class="fas fa-chart-pie"></i>
                </div>
                <a href="#" class="small-box-footer">
                  More info
                  <i class="fa fa-arrow-circle-right"></i>
                </a>
              </div>
            </div>
          </div>
        </div><hr>
        <div>
          <h6 class="text-center">ตารางสถานะงาน</h6>
          <table class="table table-bordered table-hover table-striped">
            <thead>
              <tr>
                <th>ลำดับ</th>
                <th>เลขที่ใบสั่งซื้อ</th>
                <th>ชื่อลูกค้า</th>
                <th>จำนวนรายการ</th>
                <th>จำนวนเงิน</th>
                <th>สถานะชำระเงิน</th>
                <th>สถานะจัดส่งสินค้า</th>
                <th>วันที่สั่งซื้อ</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(work,index) in workStatus" :key="work.index">
                <td class="text-center">{{++index}}</td>
                <td>{{work.order_id}}</td>
                <td>{{work.cus_name}} {{work.cus_lastname}}</td>
                <td class="text-center">{{work.list_product}}</td>
                <td class="text-right">{{work.total_price | numberFormat}} บาท</td>
                <td class="text-center">{{work.status}}</td>
                <td class="text-center">{{work.delivery_status}}</td>
                <td>{{work.created_at}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import Header from "../components/HeaderBack";
export default {
  components: {
    Header,
  },
  data(){
    return {
      pageShow: false,
      workStatus:{}
    }
  },
  beforeCreate() {
    this.axios.post('http://pgm01.toonjob.com/2019/BannKlong/project/checkBeforeLogin', {
        keyid: this.$session.get('keyid'),
        keyserial: this.$session.get('keyserial'),
        keytoken: this.$session.get('keytoken'),
      })
      .then((response) => {
        if(response.data.checkLogin === 0){
          this.pageShow = false
          window.location.href = '/pageLogin'
        }else{
          this.pageShow = true
        }
      })
  },
  methods:{
    allWorkStatus(){
      this.axios.get('http://pgm01.toonjob.com/2019/BannKlong/project/allWorkStatus')
      .then(res =>{
        this.workStatus = res.data
      })
    }
  },
  created() {
    this.$Progress.start()
    this.allWorkStatus()
    this.$Progress.finish()
  }
};
</script>


// WEBPACK FOOTER //
// src/backEnd/HomePage.vue